if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      onVariantChangeUnsubscriber = undefined;
      
      constructor() {
        super();
        this.quantityInput = this.querySelector('.quantity__input');
      }
      
      connectedCallback() {
        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
      }
      
      disconnectedCallback() {
        if (this.onVariantChangeUnsubscriber) {
          this.onVariantChangeUnsubscriber();
        }
      }
      
      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;
        this.resetProductFormState();
        setTimeout(() => {
          this.updatePrice();
          if (this.productForm && typeof this.productForm.toggleSubmitButton === 'function') {
            this.productForm.toggleSubmitButton(false);
          }
        }, 50);
      }
      
      updatePrice() {
        const productId = this.dataset.productId;
        if (!productId) {
          console.error("Missing data-product-id on <product-info>");
          return;
        }
        const jsonScript = document.getElementById('ProductJSON-' + productId);
        if (!jsonScript) {
          console.error("Product JSON not found for product id", productId);
          return;
        }
        let productData;
        try {
          productData = JSON.parse(jsonScript.textContent);
        } catch (e) {
          console.error("Error parsing product JSON:", e);
          return;
        }
        const variantInput = this.productForm?.querySelector("input[name='id']");
        if (!variantInput) {
          console.error("Variant input not found in product-form");
          return;
        }
        const variantId = variantInput.value;
        if (!variantId) {
          console.warn("No variant id set in the hidden input");
          return;
        }
        const variant = productData.variants.find(v => v.id == variantId);
        if (!variant) {
          console.warn("Variant not found for id", variantId);
          return;
        }
        let newPriceHTML = '';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          newPriceHTML = `
            <div class="price__container">
              <div class="price__regular">
                <span class="visually-hidden">Regular price</span>
                <span class="price-item price-item--regular"><s>${this.formatMoney(variant.compare_at_price)}</s></span>
              </div>
              <div class="price__sale" style="
    display: block;
">
                <span class="visually-hidden">Sale price</span>
                <span class="price-item price-item--sale price-item--last">${this.formatMoney(variant.price)}</span>
              </div>
            </div>
          `;
        } else {
          newPriceHTML = `
            <div class="price__container">
              <div class="price__regular">
                <span class="visually-hidden">Regular price</span>
                <span class="price-item price-item--regular">${this.formatMoney(variant.price)}</span>
              </div>
            </div>
          `;
        }
        const sectionId = this.dataset.section;
        const priceContainer = this.querySelector("#price-" + sectionId);
        if (priceContainer) {
          priceContainer.innerHTML = newPriceHTML;
          console.log("Price updated to:", newPriceHTML);
        } else {
          console.error("Price container not found with id:", "price-" + sectionId);
        }
      }
      
      formatMoney(amount) {
        return "$" + (amount / 100).toFixed(2) + " USD";
      }
      
      resetProductFormState() {
        if (this.productForm && typeof this.productForm.toggleSubmitButton === 'function') {
          this.productForm.toggleSubmitButton(true);
          if (typeof this.productForm.handleErrorMessage === 'function') {
            this.productForm.handleErrorMessage();
          }
        }
      }
      
      get productForm() {
        return this.querySelector('product-form');
      }
    }
  );
}
